import { RegionalizacaoCodigoEnum, RegionalizacaoEnum } from "../enum/lenguage";

export function getRegionalizationCode(countryCode?: string): number {
  switch (countryCode) {
    case RegionalizacaoCodigoEnum.Colombia:
      return RegionalizacaoEnum.CO;
    case RegionalizacaoCodigoEnum.Peru:
      return RegionalizacaoEnum.PE;
    case RegionalizacaoCodigoEnum.Equador:
      return RegionalizacaoEnum.EC;
    case RegionalizacaoCodigoEnum.Brasil:
    default:
      return RegionalizacaoEnum.BR;
  }
}
